/**
 * Erros do client do Firebase que a entrada federada e o vínculo de provedor
 * tratam igual nos dois apps. Mora aqui porque o texto que a pessoa lê tem de
 * ser o mesmo em toda tela que abre um popup.
 */

/** Código de erro do próprio Firebase (`auth/...`), quando o erro é do client. */
export function firebaseErrorCode(err: unknown): string {
  return typeof err === 'object' && err !== null && 'code' in err
    ? String((err as { code: unknown }).code)
    : '';
}

/**
 * Popup fechado pela pessoa: desistência, não falha — não vira mensagem.
 * `auth/popup-blocked` **não** entra: quem bloqueou foi o navegador, e sem
 * mensagem a pessoa clica e não vê nada acontecer.
 */
export const CANCELLED_POPUP_CODES = new Set([
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
]);

/**
 * Tenant Entra que exige aprovação do administrador para o app (consentimento
 * do usuário bloqueado). O Firebase não tem código próprio para isso: o
 * `AADSTS…` vem na mensagem.
 * ponytail: casa pela mensagem; troca pelo `code` quando a bateria em dev o
 * capturar (login-com-microsoft.md § Rollout).
 */
const ADMIN_CONSENT_REQUIRED = /AADSTS(65001|90094)/;

/**
 * Mensagem para um erro do Firebase sem ramo próprio no fluxo, em pt-BR —
 * nunca o `err.message` do SDK, que é em inglês. `null` quando o erro não é do
 * Firebase e quem chama decide.
 */
export function firebaseErrorMessage(err: unknown): string | null {
  const code = firebaseErrorCode(err);
  if (code === 'auth/popup-blocked') {
    return 'O navegador bloqueou a janela de login. Libere pop-ups para este site e tente de novo.';
  }
  if (err instanceof Error && ADMIN_CONSENT_REQUIRED.test(err.message)) {
    return 'Sua organização exige aprovação do administrador para usar o login Microsoft. Peça ao TI ou entre com e-mail e senha.';
  }
  if (code.startsWith('auth/')) {
    return 'Não foi possível concluir agora. Tente de novo em instantes.';
  }
  return null;
}
